<template>
  <div class="flex justify-center">
    <LottieAnimation
      :animation-data="FinalAnimation"
      loop
      class="scale-[2.1]"/>
  </div>
</template>

<script setup lang="ts">
import { LottieAnimation } from 'lottie-web-vue';
import FinalAnimation from '@/apps/slideshowGame/animations/final.json';

interface IProps {
  loop?: boolean;
  animationPath?: string;
  width?: string;
  height?: string;
}

withDefaults(defineProps<IProps>(), {
  loop: true,
  animationPath: '@/apps/slideshowGame/animations/final.json',
  width: '500px',
  height: '500px',
});
</script>
